import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/scrollTop";

const Homepage = lazy(() => import("./Pages/Homepage"));
const AdminLogin = lazy(() => import("./Pages/Admin/AdminLogin"));
// const AdminDashboard = lazy(() => import("./Pages/Admin/AdminDashboard"));
const AuthGuard = lazy(() => import("./Pages/Admin/AuthGuard"));
const Settings = lazy(() => import("./Pages/Admin/Settings"));
const PhotoSlider = lazy(() => import("./Pages/Admin/PhotoSlider"));
const PlayList = lazy(() => import("./Pages/Admin/PlayList"));  
const ImageGallary = lazy(() => import("./Pages/Admin/ImageGallary"));
const VideoGallary = lazy(() => import("./Pages/Admin/VideoGallary"));
const SocialMedia = lazy(() => import("./Pages/Admin/SocialMedia"));
const ContactList = lazy(() => import('./Pages/Admin/ContactList'))

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <div>
          <div className="loader">
            {/* Preloader inner */}
            {/* <div className="loader-inner">
              <svg
                width={120}
                height={120}
                viewBox="0 0 100 100"
                className="loading-spinner"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="spinner"
                  cx={50}
                  cy={50}
                  r={21}
                  fill="#13181d"
                  strokeWidth={2}
                />
              </svg>
            </div> */}
            {/* End preloader inner */}
          </div>
        </div>
      }
    >
       {/* <ScrollToTop></ScrollToTop> */}
      <Routes>
      
        <Route path="/" element={<Homepage />} />
        <Route path="/admin" element={<AdminLogin />} />
        {/* <Route
          path="/dashboard"
          element={
            <AuthGuard>
              {" "}
              <AdminDashboard />{" "}
            </AuthGuard>
          }
        /> */}
        <Route
          path="/settings"
          element={
            <AuthGuard>
              {" "}
              <Settings />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/photoslider"
          element={
            <AuthGuard>
              {" "}
              <PhotoSlider />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/videogallery"
          element={
            <AuthGuard>
              {" "}
              <VideoGallary />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/imagegallery"
          element={
            <AuthGuard>
              {" "}
              <ImageGallary />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/socialmedia"
          element={
            <AuthGuard>
              {" "}
              <SocialMedia />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/playlist"
          element={
            <AuthGuard>
              {" "}
              <PlayList />{" "}
            </AuthGuard>
          }
        />
        <Route
          path="/contact"
          element={
            <AuthGuard>
              {" "}
              <ContactList />{" "}
            </AuthGuard>
          }
        />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Suspense>
       
  );
};

export default AppRoutes;
